import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useWindowSize from '../atoms/WindowWidth.jsx';
import { toNumber } from 'lodash';

const ProgressBar = (props) => {
    const [showValue, setShowValue] = useState(false);
    const { windowWidth } = useWindowSize();

    const percentage = ((props.currentCap / props.fullCap) * 100);

    const handleShowValue = () => {
        setShowValue(true);
        setTimeout(() => setShowValue(false), 3000);
    };

    useEffect(() => {
        if (windowWidth <= 600) {
            setShowValue(true);
        }
    }, [windowWidth]);

    return (
        <div
            className={`${props.wrapperStyle} relative flex items-center gap-3`}
            onMouseEnter={windowWidth <= 600 ? () => { } : handleShowValue}
        >
            {props.label &&
                <label className={`${props.labelStyle}`}>
                    {props.label}
                </label>
            }

            <div style={{ height: `${props.height}px` }} className={`${props.barStyle} bg-white h-[20px] overflow-hidden w-full`}>
                <div style={{ width: `${percentage > 0 ? percentage : 0}%` }} className={`${props.loaderStyle} bg-slate-400 animate-slide_right2 h-full`}></div>
            </div>

            {showValue &&
                <p className={`${props.percentageStyle} absolute right-0 ml-3 text-sm font-medium`}>
                    {toNumber(percentage.toFixed(2))}%
                </p>
            }
        </div>
    );
};

ProgressBar.propTypes = {
    currentCap: PropTypes.number.isRequired,
    fullCap: PropTypes.number.isRequired,
    wrapperStyle: PropTypes.string,
    label: PropTypes.string,
    labelStyle: PropTypes.string,
    barStyle: PropTypes.string,
    loaderStyle: PropTypes.string,
    percentageStyle: PropTypes.string,
    height: PropTypes.number
};

ProgressBar.defaultProps = {
    wrapperStyle: '',
    label: '',
    labelStyle: '',
    barStyle: '',
    loaderStyle: '',
    percentageStyle: '',
    height: 20
};

export default ProgressBar;
